import React from "react";
import Messages from "../../../Shared/Messages";
import I18nProvider from "../../../services/I18nProvider";

const intl = I18nProvider.getIntlProvider();

const VoiceInputButton = ({ isRecording, isInitializing, onToggle }) => {
  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
      className={"tip-button " + (isRecording ? "tip-is-active" : "")}
      title={
        isRecording
          ? intl.formatMessage(Messages.stopRecording)
          : intl.formatMessage(Messages.startAmbientRecording)
      }
      disabled={isInitializing}
      tabIndex="-1"
      style={{
        position: "relative",
        animation: isRecording ? "pulse 1.5s infinite" : "none",
      }}
    >
      <i
        className="fa fa-microphone"
        style={{
          fontSize: "0.875rem",
          opacity: isRecording ? 1 : 0.7,
          color: isRecording ? "#dc3545" : undefined,
          marginRight: 4,
        }}
      />
      <span style={{ fontSize: "0.8rem" }}>
        {isRecording
          ? intl.formatMessage(Messages.stop)
          : intl.formatMessage(Messages.record)}
      </span>
      <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }`}</style>
    </button>
  );
};

export default VoiceInputButton;
